import { Check } from "lucide-react";
import { cn } from "@/lib/utils/cn";

const STEPS = [
  { number: 1, label: "Dates" },
  { number: 2, label: "Room" },
  { number: 3, label: "Add-ons" },
  { number: 4, label: "Details" },
  { number: 5, label: "Payment" },
];

interface BookingStepperProps {
  currentStep: number;
}

export default function BookingStepper({ currentStep }: BookingStepperProps) {
  return (
    <div className="flex items-center justify-center">
      {STEPS.map((step, idx) => {
        const isCompleted = currentStep > step.number;
        const isActive = currentStep === step.number;

        return (
          <div key={step.number} className="flex items-center">
            <div className="flex flex-col items-center gap-1.5">
              <div
                className={cn(
                  "flex h-8 w-8 items-center justify-center rounded-full border-2 text-sm font-medium transition-all sm:h-9 sm:w-9",
                  isCompleted
                    ? "border-metro-green-800 bg-metro-green-800 text-white"
                    : isActive
                      ? "border-metro-green-800 bg-white text-metro-green-800"
                      : "border-gray-200 bg-white text-metro-ink-subtle",
                )}
              >
                {isCompleted ? (
                  <Check size={14} strokeWidth={2.5} />
                ) : (
                  step.number
                )}
              </div>
              {/* Label — hidden on very small screens, visible from sm up */}
              <span
                className={cn(
                  "hidden text-[10px] font-medium sm:block sm:text-[11px]",
                  isActive
                    ? "text-metro-green-800"
                    : isCompleted
                      ? "text-metro-ink-muted"
                      : "text-metro-ink-subtle",
                )}
              >
                {step.label}
              </span>
            </div>

            {/* Connector */}
            {idx < STEPS.length - 1 && (
              <div
                className={cn(
                  "mx-1.5 mb-5 h-px w-6 transition-all sm:mx-2 sm:w-12",
                  isCompleted ? "bg-metro-green-800" : "bg-gray-200",
                )}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}